import React, { Component } from "react";
import { connect } from "react-redux";
import { parseString } from "xml2js";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import api from "../../api";
import {
  addItemToProgress,
  removeItemFromProgress,
} from "../../actions/progressList";
import { getDobDate } from "../common/DisplayDate";
import PhysicalDescription from "./PhysicalDescription";
import AliasesDetail from "./AliasesDetail";
import AddressDetail from "./AddressDetail";
import Offenses from "./Offenses";
import SimpleAccordionContent from "../common/SimpleAccordionContent";

class CriminalReportSection extends Component {
  constructor(props) {
    super(props);
    const { internalID, savedResultID } = props.additionalData;
    this.state = {
      activeIndex: 0,
      list: [],
      savedResultID,
      internalID,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID &&
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadSection = (node, props) => {
    const records = _.get(
      node,
      "personReport.crimaddons[0].inmateSearch[0].criminalinformation[0].records[0].record"
    );
    this.setState({
      records,
    });
    props.updateItemCountBySection(
      props.sectionName,
      records === undefined ? 0 : records.length
    );
  };

  loadData = (props) => {
    const sectionNode = _.get(props.reportData, "personReport.crimaddons[0]");
    if (sectionNode) {
      this.loadSection(props.reportData, props);
    } else {
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "crimaddon";
      api.report
        .person(additionalData, props.cancelToken)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            this.loadSection(rslt, props);
          });
        })
        .catch((err) => console.log("criminal addon res error - ", err));
    }
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const list = [];
    if (this.state.records !== undefined && this.state.records.length > 0) {
      _.forEach(this.state.records, (record, index) => {
        let fullNameWithJurisdiction = "";
        if (record !== undefined) {
          fullNameWithJurisdiction = `${record.fullName[0]._} ${record.sourceorjurisdiction[0]._}`;
        }
        const rows = [];
        const addNode = _.get(record, `addresses[0].address[0]`);
        rows.push(
          <Table.Row
            id={`inst_crim_row_${index}`}
            key={`inst_crim_row_${index}`}
          >
            <Table.Cell>
              <PhysicalDescription descNode = {record} {...this.props} />
              {_.get(record, "aliases[0].alias[0]") !== undefined ? (
                <AliasesDetail
                  aliasNode={record.aliases[0]}
                  dob={getDobDate(_.get(record, "fulldob[0]._", ""), {
                    userAccount: this.props.userAccount,
                    isDobValue: true,
                  })}
                />
              ) : (
                <span />
              )}
              {addNode !== undefined ? (
                <AddressDetail addNode={addNode} {...this.props} />
              ) : (
                <span />
              )}
              <Offenses
                offensesNode = {_.get(record, "offenses[0]")}
                {...this.props}
                caseNumber={_.get(record, "caseNumber[0]")}
                countyorjurisdiction={_.get(record, "countyorjurisdiction[0]")}
              />
            </Table.Cell>
          </Table.Row>
        );
        list.push(
          <SimpleAccordionContent
            {...this.props}
            name={fullNameWithJurisdiction}
            rows={rows}
            key={`inst_crim_acc_${index}`}
            accId={`inst_crim_acc_${index}`}
          />
        );
      });

    } else {
      list.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={100}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    return (
      <Accordion fluid styled id={`nav_${this.props.sectionName}`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Rep_Crim_Addon_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Criminal Records Involving Subject - Primary Source
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Rep_Crim_Addon_Body`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{list}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

function mapStateToProps(state) {
  return {
    cancelToken: state.apiCancelSource
      ? state.apiCancelSource.token
      : undefined,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, {
  addItemToProgress,
  removeItemFromProgress,
})(CriminalReportSection);



// WEBPACK FOOTER //
// ./src/components/reports/CriminalReportSection.js